import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../../../common/actions';
// report-common
import { getReportReducers } from '../../../../report-common';
// feature dispatch-report/load/load-by-order
import * as A from './actions';
//////////////////////////////////////////////////

const {
  setReports,
  selectItem,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers();

const setShouldRefreshPage = (state, shouldRefresh) =>
  P.$set('shouldRefreshPage', shouldRefresh, state);

export default createReducer({
  // report common
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.setShouldRefreshPage]: setShouldRefreshPage,
  [A.resetListAndPagination]: resetListAndPagination,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
  // report common
}, initialState);
